export default __webpack_public_path__ + "static/media/upLine.4afba33c.svg";